<template>
  <div class="container">
    <CommonFrame 
      :workNo="workNo"
      :btns="btns"
      :node="node"
      :breadcrumb="breadcrumb"
      :endStatus="approvalParams.endStatus"
      :approvalTabStatus="approvalParams.approvalTabStatus"
    >
      <div slot="info">
        <span v-for="(item,index) in infosArr" class="padding-span" :key="index">
          <span>
            {{item.name}}
          </span>:
          <span>
            {{item.value}}
          </span>
        </span>
      </div>
      <div slot="tableInfo">
        <div class="cardContainer">
          <lk-card title="申请内容">
            <receiveLimitContent
              :formObject="applyObject"
              :fieldData="drugInfo"
              :config="applyContents"
            ></receiveLimitContent>
          </lk-card>
        </div>
      </div>
    </CommonFrame>
  </div>
</template>

<script>
import axios from 'axios';
import CommonFrame from '../commonFrame.vue';
import utils from '../../../libs/utils';
import receiveLimitContent from '../../../components/sale/receiveLimitContent.vue';

export default {
  name: 'Breakage',
  props: {
    approvalParams: {
      type: Object,
    },
  },
  components: {
    CommonFrame,
    receiveLimitContent,
  },
  data() {
    return {
      drugInfo: {},
      applyObject: {},
      workNo: '',
      node: '',
      applyContents: [
        [
          {
            type: 'span',
            title: '申请门店',
            key: 'storeName'
          },
          {
            type: 'span',
            title: '申请月份',
            key: 'takeMonth'
          },
        ],
        [
          {
            type: 'inputSearch',
            title: '申请商品',
            isShowInputSearch: false,
            value: '',
            showFields: [
              {
                title: '商品编码：',
                key: 'serialCode'
              },
              {
                title: '通用名：',
                key: 'approvedDrugNames'
              },
              {
                title: '商品名：',
                key: 'goodsName'
              },
              {
                title: '规格：',
                key: 'specifications'
              },
              {
                title: '包装单位：',
                key: 'drugMiniPackageUnit'
              },
              {
                title: '生产厂家：',
                key: 'producer'
              },
              {
                title: '采购价：',
                key: 'purchasePrice',
                isCheck: true,
              },
              {
                title: '零售价：',
                key: 'retailPrice'
              },
              {
                title: '税率：',
                key: 'outputTaxRate'
              },
            ],
          },
        ],
        [
          {
            type: 'span',
            title: '未核销应收总数',
            key: 'verificationNum'
          },
          {
            type: 'span',
            title: '本月已申请限额',
            key: 'appliedAmount',
          },
        ],
        [
          {
            type: 'span',
            title: '本月已使用限额',
            key: 'usedMonth',
          },
          {
            type: 'span',
            title: '月均销售数量（近3月）',
            key: 'saleAveNum',
          },
        ],
        [
          {
            type: 'span',
            title: '本次申请数量',
            key: 'approvalAmount',
          },
          {
            type: 'span',
            title: '计划应收金额',
            key: 'receivablePrice',
          },
        ],
        [
          {
            type: 'span',
            title: '计划回款时间',
            key: 'receivableTime',
          },
          {
            type: 'upload',
            title: '附件',
            isCanEdit: false,
            uploadInfo: [
              {
                appendixName: '',
                appendixUrl: '',
              },
            ]
          }
        ],
        [
          {
            title: '申请原因',
            type: 'span',
            key: 'reason'
          }
        ]
      ],
      breadcrumb: [
        {
          name: 'work',
          title: '审批列表',
        },
        {
          name: 'approvalEdit',
          title: '应收限额审批',
        },
      ],
      btns: [
        {
          name: 'reject',
          text: '驳回',
          type: 'default',
        },
        {
          name: 'pass',
          text: '通过',
          type: 'primary',
        },
      ],
      infosArr: [],
    };
  },
  methods: {
    getReceiveLimitInfo(businessUrl) {
      axios.get(businessUrl).then((res) => {
        let data = res.data.data;
        data.takeMonth = utils.formatDateToMonth(data.takeMonth);
        data.receivableTime = utils.formatDate(data.receivableTime);
        data.outputTaxRate = `${data.outputTaxRate}%`;
        this.infosArr = data.infos;
        this.drugInfo = data;
        this.applyContents[1][0].value = data.serialCode || '';
        this.applyContents[5][1].uploadInfo = data.bizExtraVos;
        this.applyObject = data;
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.workNo = this.approvalParams.workNo;
    this.node = this.approvalParams.node;
    this.getReceiveLimitInfo(this.approvalParams.businessUrl);
  },
};
</script>
